module.exports = __webpack_public_path__ + "static/media/tile-12.84fc39b4.jpg";